import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { config as generalConfig } from '../../../config';
import { hasValue } from '../../../utils/asyncState';
import { protocolAndHost } from '../../../utils/browser';
import { Container } from '../../Container';
import { Link } from '../../Link';
import { Pager } from '../../Pager';
import { pushCollectionAction } from '../CollectionUtils';
import { Filter } from './CollectionOverviewFilter';
import { CollectionSearchResult } from './CollectionOverviewResult';
import { searchParams } from './CollectionOverviewUtils';
const React = require('react');
export const collectionResultsId = 'collection-results';
export const CollectionOverviewLayout = (param)=>{
    let { response, facets, filterSettings, filterUpdaters, config, filterExpanded, toggleFilterExpanded, history, preferredBranchId } = param;
    const canonical = protocolAndHost() + config.route;
    const index = window.location.href == canonical ? 'index, nofollow' : 'noindex, nofollow';
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Helmet, {
                children: [
                    filterSettings.query && response.kind == 'loaded' ? /*#__PURE__*/ _jsxs("title", {
                        children: [
                            'Zoekresultaten voor "',
                            filterSettings.query,
                            '"'
                        ]
                    }) : /*#__PURE__*/ _jsx("title", {
                        children: "Zoek in de collectie"
                    }),
                    /*#__PURE__*/ _jsx("link", {
                        rel: "canonical",
                        href: `${protocolAndHost()}${config.route}`
                    }),
                    /*#__PURE__*/ _jsx("meta", {
                        name: "robots",
                        content: `${index}, nofollow`
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "general-page collection__page",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "collection__header",
                        children: /*#__PURE__*/ _jsxs(Container, {
                            size: "m",
                            gutter: true,
                            className: "align--center",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "collection__breadcrumbs",
                                    "aria-label": "Breadcrumb",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            url: "/",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ _jsx("svg", {
                                            width: "1.6rem",
                                            height: "1.6rem",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ _jsx("use", {
                                                xlinkHref: "#icon--chevron-right"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(Link, {
                                            url: "/collectie",
                                            children: "Lezen"
                                        }),
                                        /*#__PURE__*/ _jsx("svg", {
                                            width: "1.6rem",
                                            height: "1.6rem",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ _jsx("use", {
                                                xlinkHref: "#icon--chevron-right"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "Overzicht"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("h1", {
                                    className: "title--xl collection__page-title",
                                    children: "Zoek in de collectie"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Container, {
                        size: "m",
                        gutter: true,
                        className: "align--center",
                        children: /*#__PURE__*/ _jsx("section", {
                            id: "collection",
                            className: "collection",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "collection__grid",
                                children: [
                                    /*#__PURE__*/ _jsx(QueryField, {
                                        className: "collection__queryfield",
                                        query: filterSettings.query,
                                        updateQuery: filterUpdaters.updateQuery
                                    }),
                                    /*#__PURE__*/ _jsx(Filter, {
                                        className: "collection__filter",
                                        facets,
                                        filterSettings,
                                        filterUpdaters,
                                        filterExpanded,
                                        toggleFilterExpanded,
                                        config,
                                        preferredBranchId
                                    }),
                                    /*#__PURE__*/ _jsx(Result, {
                                        className: "collection__result",
                                        response,
                                        config,
                                        history,
                                        selectedBranch: filterSettings.location
                                    })
                                ]
                            })
                        })
                    })
                ]
            }, "collection-overview-loaded")
        ]
    });
};
const QueryField = (param)=>{
    let { query, updateQuery, className } = param;
    const push = pushCollectionAction();
    const SearchIcon = generalConfig().ui.SearchIcon;
    const [inputValue, setInputValue] = useState(query);
    // Sync local input state from query prop (from URL) on mount or when query changes
    useEffect(()=>{
        setInputValue(query);
    }, [
        query
    ]);
    const pushAndRun = ()=>{
        push('search', inputValue);
        updateQuery(inputValue); // updateQuery should update state and URL
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: className,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "c-query__title",
                children: "Zoek"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "c-query__input--wrapper",
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        className: "c-query__input form__input",
                        id: "search",
                        type: "text",
                        placeholder: "Titel, auteur of ISBN",
                        value: inputValue,
                        onChange: (e)=>setInputValue(e.target.value),
                        autoComplete: "on",
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') pushAndRun();
                        }
                    }),
                    /*#__PURE__*/ _jsxs("button", {
                        className: "c-query__run-query",
                        onClick: pushAndRun,
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "sr-text",
                                children: "Zoeken"
                            }),
                            SearchIcon
                        ]
                    })
                ]
            })
        ]
    });
};
const Result = (param)=>{
    let { response, config, className, history, selectedBranch } = param;
    let results = /*#__PURE__*/ _jsx(_Fragment, {});
    switch(response.kind){
        case 'loading':
        case 'loaded':
            if (hasValue(response)) results = /*#__PURE__*/ _jsx(Results, {
                response: response.value,
                config,
                history,
                selectedBranch
            });
            break;
        case 'unloaded':
            results = /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "c-filter__header",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "c-filter__title title--ms",
                            children: "Doorzoek hier de collectie"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx("p", {
                            children: "Zoek bijvoorbeeld op titel, auteur of onderwerp."
                        })
                    })
                ]
            });
            break;
        default:
            results = /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "c-filter__header",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "c-filter__title title--ms",
                            children: "Oeps!"
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                children: "Er is iets misgegaan tijdens het laden."
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                children: [
                                    "Status: ",
                                    response.kind
                                ]
                            })
                        ]
                    })
                ]
            });
    }
    return /*#__PURE__*/ _jsx("div", {
        className: className,
        id: collectionResultsId,
        children: results
    });
};
const Results = (props)=>{
    const { response: { Result, TotalResults: totalResults, CurrentParams }, config, history, selectedBranch } = props;
    const { route } = config;
    const push = pushCollectionAction();
    const { offset, limit: pageSize } = CurrentParams;
    const currentPage = Math.floor(offset / pageSize) + 1;
    const setPage = (pageNumber)=>{
        const offset = (pageNumber - 1) * pageSize;
        const newParams = {
            ...CurrentParams,
            offset
        };
        push('Navigeer naar pagina', pageNumber.toString());
        history.push(`${route}${searchParams(newParams)}`);
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: Result && Result.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "c-filter__header",
                    children: /*#__PURE__*/ _jsxs("h3", {
                        className: "c-filter__title",
                        children: [
                            totalResults,
                            " resultaten"
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("ul", {
                    children: props.response.Result.map((result)=>/*#__PURE__*/ _jsx(CollectionSearchResult, {
                            item: result,
                            config,
                            selectedBranch
                        }, `${result.Id}-${selectedBranch}`))
                }),
                /*#__PURE__*/ _jsx(Pager, {
                    currentPage,
                    setPage,
                    pageSize,
                    totalResults,
                    containerSize: "s"
                })
            ]
        }) : /*#__PURE__*/ _jsx("div", {
            children: "Niets gevonden"
        })
    });
};
